import { render, staticRenderFns } from "./breadcrumb-item.vue?vue&type=template&id=07212a21&"
import script from "./breadcrumb-item.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07212a21')) {
      api.createRecord('07212a21', component.options)
    } else {
      api.reload('07212a21', component.options)
    }
    module.hot.accept("./breadcrumb-item.vue?vue&type=template&id=07212a21&", function () {
      api.rerender('07212a21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/breadcrumb/breadcrumb-item.vue"
export default component.exports